import { Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { ImportFtpFileImportComponent } from '../import-ftp-file-import/import-ftp-file-import.component';
import * as XLSX from 'xlsx';
@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false // NOSONAR
})
export class FileUploadComponent implements OnDestroy {


  progress: number = 0;
  fileName = '';
  @ViewChild('fileUpload') myInputVariable: ElementRef;
  // file:File;
  @Output() updateEvent = new EventEmitter();
  progressTimer: ReturnType<typeof setInterval> | null = null;
  uploadagain: boolean;
  validateFile: boolean = true;
  sheetNames: any;
  private readonly supportedExtensions = ['.xlsx', '.xls', '.csv'];
  constructor(public importComponent:ImportFtpFileImportComponent) { }

  private getFileExtension(fileName: string): string {
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex < 0) {
      return '';
    }
    return fileName.substring(dotIndex).toLowerCase();
  }

  private isExcelExtension(extension: string): boolean {
    return extension === '.xls' || extension === '.xlsx';
  }

  private isSupportedExtension(extension: string): boolean {
    return this.supportedExtensions.includes(extension);
  }

  onFileSelected(event: any) {
    this.importComponent.upload = false;
    const file: File = event.target.files[0];
    this.updateEvent.emit(file);
    const reader: FileReader = new FileReader();
  reader.onload = (e: any) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: 'array' });
    // Get sheet names
    const sheetNames = workbook.SheetNames;
    this.sheetNames = sheetNames;
    this.fileName = file.name;
    const extension = this.getFileExtension(this.fileName);

    if (!this.isSupportedExtension(extension)) {
      alert('Can accept only .xlsx, .xls and .csv files');
      this.importComponent.upload = true;
      this.progress = 0;
      return;
    }

    if (this.isExcelExtension(extension)) {
      if (this.sheetNames.includes('Events') && this.sheetNames.includes('Resolutions')) {
        this.validateFile = true;
        this.uploadFile(file);
      } else {
        this.validateFile = false;
        this.importComponent.checkFile(this.validateFile);
      }
      return;
    }

    // CSV support: allow upload and let backend/lambda validate structure.
    this.validateFile = true;
    this.uploadFile(file);
  };
  reader.readAsArrayBuffer(file);
  }
  uploadFile(file: File) {
    this.clearProgressTimer();
    this.progress = 0;
    this.progressTimer = setInterval(() => {
      this.progress = Math.min(this.progress + 10, 100);
      if (this.progress >= 100) {
        this.clearProgressTimer();
      }
    }, 100);
  }

  private clearProgressTimer() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer);
      this.progressTimer = null;
    }
  }


  cancelUpload() {
    this.clearProgressTimer();
    this.updateEvent.emit(null);
    this.progress = 0;
  }


  ngOnDestroy() {
    this.cancelUpload();
  }
}
